<div class="container">
  <div class="row mt-5">
    <div class="col-12">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_245_1774)">
          <path d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z" fill="#009DFF"/>
        </g>
        <defs>
          <clipPath id="clip0_245_1774">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <label class="back" (click)="goBack()">Back</label>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-12">
      <div class="header-text">Additional Benefits of Your Plan</div>
    </div>
  </div>

  <app-ancillary-benefits [ancillaryCodes]="ancillaryCodes"></app-ancillary-benefits>

  <div>
    <span class="sub-text2">
      Find a provider of these benefits by clicking <a (click)="navigateToSearch()" class="ancillary-link clickable">here</a>.
    </span>
  </div>
  <div class="row mt-5"></div>  
</div>
